module.exports = __webpack_public_path__ + "static/media/loading.e5c08f4b.gif";